import { observer } from 'mobx-react-lite'
import type { CSSProperties, FC } from 'react'
import { useCallback } from 'react'
import type { CreateDataGrantModalStore } from './modal-store'
import { CreateDataGrantModalStep } from './modal-store'
import { Modal } from '../../../../../components/modal'
import type { Placement } from '@floating-ui/react'
import { useOrganization } from '../../../../../stores/organization-store'
import type { Stores } from '../../../../../util/store'

export interface CreateDataGrantConfirmationModalProps {
    anchor?: HTMLElement
    placement?: Placement
    onClose(): void
    style?: CSSProperties
    containerStyle?: CSSProperties
    stores: Stores
    store: CreateDataGrantModalStore
    providerOrganizationId: string
}

const orgNameStyle: CSSProperties = {
    color: 'var(--purple-color)',
}

export const CreateDataGrantConfirmationModal: FC<CreateDataGrantConfirmationModalProps> =
    observer(
        ({
            anchor,
            placement,
            onClose,
            style,
            containerStyle,
            stores,
            store,
            providerOrganizationId,
        }) => {
            const goToIndex = useCallback(() => {
                store.setStep(CreateDataGrantModalStep.Index)
            }, [])

            const submit = useCallback(() => {
                store.submit()
            }, [])

            const providerOrganization = useOrganization(
                stores.organizations,
                providerOrganizationId,
            )

            const consumerOrganization = useOrganization(
                stores.organizations,
                store.consumerOrganizationId,
            )

            return (
                <Modal
                    anchor={anchor}
                    placement={placement}
                    onClose={onClose}
                    style={style}
                    containerStyle={containerStyle}>
                    <p
                        style={{
                            color: 'var(--red-color)',
                        }}>
                        Are you sure?
                    </p>

                    <p>
                        This will make members from the{' '}
                        <span style={orgNameStyle}>
                            {consumerOrganization?.name}
                        </span>{' '}
                        organization have access to all work orders from the{' '}
                        <span style={orgNameStyle}>
                            {providerOrganization?.name}
                        </span>{' '}
                        organization.
                    </p>

                    <hr
                        style={{
                            width: '100%',
                            borderTop:
                                '1px solid var(--selection-color-opaque)',
                            borderBottom: 'none',
                        }}
                    />

                    <div
                        style={{
                            display: 'flex',
                            flexDirection: 'row',
                            justifyContent: 'flex-end',
                        }}>
                        <div
                            onClick={goToIndex}
                            style={{
                                cursor: 'pointer',
                                color: 'var(--comment-color)',
                            }}>
                            No
                        </div>

                        <div
                            onClick={submit}
                            style={{
                                marginLeft: '1rem',
                                cursor: 'pointer',
                                color: 'var(--green-color)',
                            }}>
                            Yes
                        </div>
                    </div>
                </Modal>
            )
        },
    )
